/*
    General component
    display UI instead of form field button.
    Displays the file uploaded

    takes in size of image it should resize the image to.
*/
import React from 'react';

import TimeFilter from 'app/employer/components/GlobalFilter/TimeFilter';

export const UpwardTimeFilterRedux = ({ input, label, meta: { touched, error }, ...custom }) => {
   return (
      <TimeFilter {...input} {...custom} fromDate={input.value.fromDate} toDate={input.value.toDate} onChange={input.onChange} />
   );
};

// <OrganizationAutoSuggest onSelection={this.onOrganizationSelection} selected={this.state.organization}></OrganizationAutoSuggest>
export const UpwardAutoSuggestRedux = ({ input, label, className, meta: { touched, error }, component: Component, childComponent: ChildComponent, ...custom }) => {
   return (
      <ChildComponent {...custom} className={(className ? className : '') + ' ' + (touched && error ? ' is-invalid ' : '')} selected={input.value} onSelection={input.onChange} {...input} />
   );
};
